import CustomizadoIndex from './CustomizadoIndex'

export const customizadoRoutes = [
  {
    name: 'customizado-index',
    path: '/customizado',
    component: CustomizadoIndex
  }
]
